<template>
  <div>
    <div class="products-banner contact-jumbo cart-back">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <h1 class="white">
              Cart
            </h1>
            <p class="white no-bottom">ATTENTION: items are sold on a first come first served basis.</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="processing">
      <div class="row space-loader d-flex align-items-center justify-content-center">
        <b-spinner style="width: 6rem; height: 6rem;" label="Large Spinner"></b-spinner>
      </div>
    </div>
    <div class="container section-padding" v-else>
      <div class="row">
        <div class="col-lg-12">
          <h2>{{numberOfCartItems}} {{itemWord}}</h2>
        </div>
        <ProductCard v-for="(product, productIndex) in productsInCart" :key="productIndex" v-bind:product="product"
          v-bind:valid="!invalidItems.includes(productIndex)" />
        <div class="col-lg-12">
          <h2 class="space-top ">Cart total: <strong>{{cartTotal}}</strong></h2>
          <p>Please submit your contact info. Frank will be in touch with shipping/pickup information as well as payment
            methods.</p>
          <h2 class="space-bottom-small space-top">Customer Information:</h2>
          <form>
            <div class="form-group">
              <label for="name">First Name:</label>
              <input v-model="form.firstname" type="text" class="form-control" id="firstname" placeholder="John" />
            </div>
            <div class="form-group">
              <label for="name">Last Name:</label>
              <input v-model="form.lastname" type="text" class="form-control" id="lastname" placeholder="Smith" />
            </div>
            <div class="form-group">
              <label for="name">Email:</label>
              <input v-model="form.email" type="email" class="form-control" id="email"
                placeholder="example@example.com" />
            </div>
            <div class="form-group space-bottom">
              <label for="name">Phone:</label>
              <input v-model="form.phone" type="tel" class="form-control" id="phone" placeholder="123-456-7890" />
            </div>
          </form>
          <div class="space-bottom" v-if="errorMessage != ''" style="color: red">{{errorMessage}}</div>

          <button @click="placeOrder" type="button" class="btn">Place Order</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "../../api/api";
  import ProductCard from "@/components/ProductCard.vue";

  export default {
    components: {
      ProductCard,
    },
    data: function () {
      return {
        products: {},
        form: {
          email: "",
          phone: "",
          firstname: "",
          lastname: "",
        },
        invalidItems: [],
        processing: false,
        errorMessage: "",
      };
    },
    computed: {
      numberOfCartItems() {
        return Object.keys(this.$store.state.cart).length;
      },
      itemWord() {
        if (this.numberOfCartItems == 1) {
          return "Item";
        }
        return "Items";
      },
      productsInCart() {
        return this.$store.state.cart;
      },
      cartTotal() {
        var total = 0;
        for (var key in this.$store.state.cart) {
          total += this.$store.state.cart[key].price;
        }
        return total.toLocaleString(undefined, {
          style: "currency",
          currency: "USD",
        });
      },
    },
    mounted() {
      this.loadProducts();
    },
    methods: {
      loadProducts() {
        this.processing = true;
        var ids = [];
        for (var key in this.$store.state.cart) {
          ids.push(key);
        }
        api.getProducts(ids)
          .then(res => {
            for (var key in this.$store.state.cart) {
              var found = res.products.find(product => product.id == key);
              if (found == undefined) {
                this.invalidItems.push(key); //Not returned by API, item may have been removed while in cart
              }
            }
          })
          // .catch(err => {
          //   console.log(err);
          // })
          .finally(() => {
            this.processing = false;
          })
      },
      validateForm() {
        let error = "";
        this.errorMessage = "";
        if (this.form.firstname == "") {
          error = error + "Must provide your first name.\n";
        }
        if (this.form.lastname == "") {
          error = error + "Must provide your last name.\n";
        }
        if (this.form.email == "" && this.form.phone == "") {
          error = error + "Must provide either an email or a phone number\n";
        }
        if (this.numberOfCartItems == 0) {
          error = error + "Must have at least one item in your cart!\n";
        }
        if (error != "") {
          this.errorMessage = error;
          return false;
        }
        return true;
      },
      placeOrder() {
        if (!this.validateForm()) return;
        this.processing = true;
        var order = {
          firstname: this.form.firstname,
          lastname: this.form.lastname,
          email: this.form.email,
          phone: this.form.phone,
          products: [],
        };
        for (var key in this.$store.state.cart) {
          order.products.push(this.$store.state.cart[key]);
        }
        api
          .createOrder(order)
          .then(() => {
            this.$store.dispatch("emptyCart");
            this.$router.push(`/order-complete`)
            this.processing = false;
          })
          .catch((err) => {
            this.invalidItems = [];
            for (var i = 0; i < err.errors.length; i++) {
              var error = err.errors[i];
              if (error.message == "Product must exist") {
                var id = error.field.split(" ")[1];
                this.invalidItems.push(id);
              }
            }
            this.errorMessage = "There are some invalid items in your cart, they may have already sold, please remove them to continue.";
          });
      },
    },
  };
</script>